<script>
import DataLabel from '@/js/components/common/labels/DataLabel';

export default {
    name: 'ActivityLabel',

    functional: true,

    props: {
        activity: {type: Object, required: true},
        hideIcon: {type: Boolean},
    },

    render(createElement, {props, data, parent}) {
        data.props = {
            item: props.activity,
            hideIcon: props.hideIcon,
            iconClass: 'far fa-fw fa-check-square',
            none: parent.$t('activities.nil'),
        };

        return createElement(DataLabel, data);
    },
};
</script>
